import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import ColorPickerListItem from '../../../../../list-items/ColorPickerListItem';
import { HexToRgb } from '../../../../../../utilities/colorUtilities';

const LyricsColorListItem = (props) => {
    const { lyricsColor, updateLyricsStyle } = props;
    let color = HexToRgb(lyricsColor);

    const onColorChange = (color) => updateLyricsStyle({ color: color.hex.replace('#', '0x') });

    return (
        <ColorPickerListItem
            text='Color'
            color={color}
            disableAlpha={true}
            onChange={onColorChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { color: lyricsColor } = state.createPreview.present.videoSettings.lyrics.style;
    return { lyricsColor };
}

const mapDispatchToProps = (dispatch) => {
    const updateLyricsStyle = (properties) => dispatch(createActions.updateLyricsStyle(properties));
    return { updateLyricsStyle }
}

export default connect(mapStateToProps, mapDispatchToProps)(LyricsColorListItem);